"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.YToXArrGroup = exports.ChildPointAdjustUtil = void 0;
const LineSegment_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/LineSegment.js"));
const Coordinate_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Coordinate.js"));
const pipeCommonUtil_1 = require("./pipeCommonUtil");
const PointLocator_js_1 = __importDefault(require("jsts/org/locationtech/jts/algorithm/PointLocator.js"));
const Location_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Location.js"));
const PointGroupJudgeTolerance = 500;
class ChildPointAdjustUtil {
    execute(xArr, yArr, polygonSegs_local, blankDis, minDisToWall, minDisBetweenSprinklers, polygon_local, boundingBox) {
        let pointLocator = new PointLocator_js_1.default();
        let yToXArr_map = new Array();
        let yToRemovedXArr_map = new Map();
        for (let y of yArr) {
            let copyXArr = xArr.concat();
            let xArrGroup = new Array();
            let adjustResult = pipeCommonUtil_1.PipeCommonUtil.adJustChildPipePoints_V2(polygonSegs_local, copyXArr, y, blankDis, minDisToWall, polygon_local);
            let newXArr = adjustResult.adjustedXArr;
            //将移除的坐标存起来
            let removedXArr = adjustResult.removedXArr;
            //上一行的X数组
            let previous_yToXArrGroup = yToXArr_map[yToXArr_map.length - 1];
            this.checkIfOneSprinkerEnough_horizontal(newXArr, removedXArr, y, previous_yToXArrGroup, blankDis, polygonSegs_local, boundingBox);
            //移除掉的点隔壁有可能会有后面补充上去的点，所以需要过滤掉这些点
            removedXArr = this.filterRemovedXArr(removedXArr, newXArr);
            yToRemovedXArr_map.set(y, removedXArr);
            if (newXArr.length == 0) {
                //空数组
            }
            else if (newXArr.length == 1) {
                xArrGroup.push([newXArr[0]]);
            }
            else {
                xArrGroup.push(new Array());
                let lastTwoPoints_are_differenceGroup = false; //判断最后两个点是否属于不同的组
                for (let i = 0; i < newXArr.length - 1; i++) {
                    xArrGroup[xArrGroup.length - 1].push(newXArr[i]);
                    //判断是否为同一个组有两个条件：
                    //1.相互间距离大于两倍blankDis则认定为不同的组。由于目前距离有调整，所以暂时+1000，增加容错
                    //2.中点在多边形内，减少连线超出房间多边形的情况
                    if (newXArr[i + 1] - newXArr[i] > 2 * blankDis + PointGroupJudgeTolerance || pointLocator.locateInPolygon(new Coordinate_js_1.default((newXArr[i] + newXArr[i + 1]) / 2, y), polygon_local) !== Location_js_1.default.INTERIOR) {
                        xArrGroup.push(new Array());
                        if (i == newXArr.length - 2) {
                            lastTwoPoints_are_differenceGroup = true;
                        }
                    }
                }
                if (lastTwoPoints_are_differenceGroup) {
                    xArrGroup.push([newXArr[newXArr.length - 1]]);
                }
                else {
                    xArrGroup[xArrGroup.length - 1].push(newXArr[newXArr.length - 1]);
                }
            }
            //将移除和调整后的结果存起来
            yToXArr_map.push(new YToXArrGroup(y, xArrGroup));
        }
        //1.要被移除的点判断一下能否向上面或下面的邻近点组靠近？
        //2.相邻两行点之间有一片空间怎么办，是个问题，补一行？好像可行
        //3.还有别的情况吗
        //开始对被移除掉的坐标进行调整或补充
        let yToXArr_removed = new Array();
        let yToXArr_middlePoint = new Array();
        for (let y of yArr) {
            let removedXArr = yToRemovedXArr_map.get(y);
            if (removedXArr === undefined || removedXArr.length == 0)
                continue;
            //对移除的点，判断一下隔壁行+喷头间最小距离(1800)，看是否能补充点，以免该喷头距离墙距离过远
            {
                let newYArrMap = this.handleRemovedXArr(y, yArr, removedXArr, minDisBetweenSprinklers, blankDis, yToXArr_map, polygon_local);
                //分组
                for (let pair of newYArrMap) {
                    let newY = pair[0];
                    let newXArr = pair[1];
                    //这里需要过滤一下哪些点是不需要补的
                    this.checkIfOneSprinkerEnough(newY, newXArr, blankDis, polygonSegs_local, boundingBox);
                    let newXArrGroup = this.groupXArr(newXArr, 2 * blankDis + PointGroupJudgeTolerance);
                    this.adjustXArrGroup_accordingToMinDistanceToWall(newY, newXArrGroup, polygon_local, yToXArr_map, yToXArr_middlePoint);
                }
            }
            //尝试能否在移除的两行之间补充点
            {
                let newYArrMap = this.addMiddlePoint(y, yArr, yToRemovedXArr_map, polygon_local, polygonSegs_local);
                //分组
                for (let pair of newYArrMap) {
                    let newY = pair[0];
                    let newXArr = pair[1];
                    let newXArrGroup = this.groupXArr(newXArr, 2 * blankDis + PointGroupJudgeTolerance);
                    this.adjustXArrGroup_accordingToMinDistanceToWall(newY, newXArrGroup, polygon_local, yToXArr_map, yToXArr_middlePoint);
                }
            }
        }
        //排序
        yToXArr_map.sort(function (a, b) { return a._y - b._y; });
        return {
            yToXArr_map: yToXArr_map,
            yToXArr_removed: yToXArr_removed,
            yToXArr_middlePoint: yToXArr_middlePoint
        };
    }
    checkIfOneSprinkerEnough_horizontal(adjustedXArr, removedXArr, y, previous_yToXArrGroup, blankDis, polygonSegs_local, boundingBox) {
        if (adjustedXArr.length < 2)
            return;
        //分组
        let groups = new Array();
        groups.push([adjustedXArr[0]]);
        for (let i = 1; i < adjustedXArr.length; i++) {
            let lastGroup = groups[groups.length - 1];
            let x = adjustedXArr[i];
            if (x - lastGroup[lastGroup.length - 1] < 2 * blankDis) {
                lastGroup.push(x);
            }
            else {
                groups.push([x]);
            }
        }
        for (let i = groups.length - 1; i >= 0; i--) {
            let group = groups[i];
            if (group.length != 2)
                continue;
            //与多边形求交
            let targetSeg = new LineSegment_js_1.default(boundingBox.min.x, y, boundingBox.max.x, y);
            let intersectPoints = [];
            for (let seg of polygonSegs_local) {
                let intersectPoint = targetSeg.intersection(seg);
                if (intersectPoint) {
                    intersectPoints.push(intersectPoint);
                }
            }
            //交点分为左右两组
            let leftX = group[0];
            let rightX = group[1];
            let leftXArr = [];
            let rightXArr = [];
            for (let point of intersectPoints) {
                if (point.x < leftX)
                    leftXArr.push(point.x);
                else
                    rightXArr.push(point.x);
            }
            let maxX_left = Math.max(...leftXArr);
            let minX_right = Math.min(...rightXArr);
            //如果这两个X值的差值小于阈值，则移除左边或右边的X
            //不能简单地移除掉右边的X，而是需要判断rightX在上一行有无相近的值，如果有则移除左边的X
            let removeLeftX = previous_yToXArrGroup && pipeCommonUtil_1.PipeCommonUtil.findValueInGroup(rightX, previous_yToXArrGroup._xArrGroup);
            let distance = minX_right - maxX_left;
            if (distance < 2 * blankDis + 500) { //加个500是为了增加容错。一般的门内陷的长度是100或120，理论上来说这个500的值偏大了，可能会造成某些问题
                //从数组中移除X
                let removedX;
                if (removeLeftX) {
                    removedX = leftX;
                    adjustedXArr.splice(adjustedXArr.indexOf(group[0]), 1);
                }
                else {
                    removedX = rightX;
                    adjustedXArr.splice(adjustedXArr.indexOf(group[1]), 1);
                }
                //移除的X加入removedXArr数组
                if (removedX < removedXArr[0]) {
                    removedXArr.unshift(removedX);
                }
                else if (removedX > removedXArr[removedXArr.length - 1]) {
                    removedXArr.push(removedX);
                }
                else {
                    for (let j = 0; j < removedXArr.length - 1; j++) {
                        if (removedX >= removedXArr[j] && removedX <= removedXArr[j + 1]) {
                            removedXArr.splice(j + 1, 0, removedX);
                            break;
                        }
                    }
                }
            }
        }
    }
    checkIfOneSprinkerEnough(newY, newXArr, blankDis, polygonSegs_local, boundingBox) {
        for (let i = newXArr.length - 1; i >= 0; i--) {
            let targetSeg = new LineSegment_js_1.default(newXArr[i], boundingBox.min.y, newXArr[i], boundingBox.max.y);
            let intersectPoints = [];
            for (let seg of polygonSegs_local) {
                let intersectPoint = targetSeg.intersection(seg);
                if (intersectPoint) {
                    intersectPoints.push(intersectPoint);
                }
            }
            //分为两组
            let underYArr = [];
            let aboveYArr = [];
            for (let point of intersectPoints) {
                if (point.y < newY)
                    underYArr.push(point.y);
                else
                    aboveYArr.push(point.y);
            }
            let maxY_under = Math.max(...underYArr);
            let minY_above = Math.min(...aboveYArr);
            //如果这两个Y值的差值小于阈值，则该X值认定为无效补充值，移除
            let distance = minY_above - maxY_under;
            if (distance < 2 * blankDis + 500) { //加个500是为了增加容错。一般的门内陷的长度是100或120，理论上来说这个500的值偏大了，可能会造成某些问题
                newXArr.splice(i, 1);
            }
        }
    }
    //判断是否需要上移或下移，满足距离墙100的最小距离的条件
    adjustXArrGroup_accordingToMinDistanceToWall(newY, newXArrGroup, polygon_local, yToXArr_map, yToXArr_middlePoint) {
        //对补充的点进行距离墙100最小距离的条件判断
        let pointLocator = new PointLocator_js_1.default();
        let map = new Map();
        for (let xArr of newXArrGroup) {
            //以xArr为单位进行判定
            let moveUp100 = false;
            let moveDown100 = false;
            for (let x of xArr) {
                let inPolygon_up100 = pointLocator.locateInPolygon(new Coordinate_js_1.default(x, newY + 100), polygon_local) === Location_js_1.default.INTERIOR;
                if (!inPolygon_up100) { //上面100不在，则向下移
                    moveDown100 = true;
                    break;
                }
                else {
                    let inPolygon_down100 = pointLocator.locateInPolygon(new Coordinate_js_1.default(x, newY - 100), polygon_local) === Location_js_1.default.INTERIOR;
                    if (!inPolygon_down100) { //下面100不在，则向上移。
                        moveUp100 = true;
                    }
                }
            }
            if (moveDown100) {
                this.addToMap(map, newY - 100, xArr);
            }
            else if (moveUp100) {
                this.addToMap(map, newY + 100, xArr);
            }
            else { //暂时不考虑上下都不在的异常情况
                this.addToMap(map, newY, xArr);
            }
        }
        for (let y of map.keys()) {
            this.addNewXArrGroup(y, map.get(y), yToXArr_middlePoint);
            this.addNewXArrGroup(y, map.get(y), yToXArr_map);
        }
    }
    addToMap(map, y, xArr) {
        if (map.has(y)) {
            map.get(y).push(xArr);
        }
        else {
            map.set(y, [xArr]);
        }
    }
    filterRemovedXArr(removedXArr, xArr) {
        function isNearToAny(removedX, xArr) {
            for (let x of xArr) {
                if (Math.abs(removedX - x) < PointGroupJudgeTolerance) {
                    return true;
                }
            }
            return false;
        }
        let newRemovedXArr = [];
        for (let removedX of removedXArr) {
            if (isNearToAny(removedX, xArr) === false) {
                newRemovedXArr.push(removedX);
            }
        }
        return newRemovedXArr;
    }
    //将xArr分组
    groupXArr(xArr, tolerance) {
        let xArrGroup = new Array();
        for (let x of xArr) {
            let lastGroup = xArrGroup[xArrGroup.length - 1];
            if (lastGroup === undefined || x - lastGroup[lastGroup.length - 1] > tolerance) {
                xArrGroup.push([x]);
            }
            else {
                lastGroup.push(x);
            }
        }
        return xArrGroup;
    }
    handleRemovedXArr(y, yArr, removedXArr, minDisBetweenSprinklers, blankDis, yToXArr_map, polygon_local) {
        let newYArrMap = new Map();
        let pointLocator = new PointLocator_js_1.default();
        //获取其他行
        let nearRows = this.findRows(y, yArr, yToXArr_map);
        if (nearRows.preRows.length > 0) { //向下
            for (let removedX of removedXArr) {
                for (let preRow of nearRows.preRows) {
                    //根据距离过滤，只计算符合距离要求的行
                    let disToPreRow = Math.abs(preRow._y - y);
                    if (disToPreRow < minDisBetweenSprinklers || disToPreRow > blankDis) {
                        continue;
                    }
                    //对符合Y方向距离要求的行，判断是否符合X方向距离要求
                    //如果符合，则直接移到喷头间最小间隔的地方，并判断是否在多边形内
                    let preXArrGroup = preRow._xArrGroup;
                    if (this.isExistedInXArrGroup(removedX, preXArrGroup) === true) {
                        let preIndex = yArr.indexOf(y) - 1;
                        let preY = yArr[preIndex];
                        let newY = preY + minDisBetweenSprinklers;
                        let newPoint = new Coordinate_js_1.default(removedX, newY);
                        let inPolygon = pointLocator.locateInPolygon(newPoint, polygon_local) === Location_js_1.default.INTERIOR;
                        if (inPolygon === false)
                            continue;
                        if (newYArrMap.has(newY) === true) {
                            newYArrMap.get(newY).push(removedX);
                        }
                        else {
                            newYArrMap.set(newY, [removedX]);
                        }
                        break;
                    }
                }
            }
        }
        if (nearRows.nextRows.length > 0) { //向上
            for (let removedX of removedXArr) {
                for (let nextRow of nearRows.nextRows) {
                    let disToPreRow = Math.abs(nextRow._y - y);
                    if (disToPreRow < minDisBetweenSprinklers || disToPreRow > blankDis) {
                        continue;
                    }
                    let nextXArrGroup = nextRow._xArrGroup;
                    if (this.isExistedInXArrGroup(removedX, nextXArrGroup) === true) {
                        let nextIndex = yArr.indexOf(y) + 1;
                        let nextY = yArr[nextIndex];
                        let newY = nextY - minDisBetweenSprinklers;
                        let newPoint = new Coordinate_js_1.default(removedX, newY);
                        let inPolygon = pointLocator.locateInPolygon(newPoint, polygon_local) === Location_js_1.default.INTERIOR;
                        if (inPolygon === false)
                            continue;
                        if (newYArrMap.has(newY) === true) {
                            newYArrMap.get(newY).push(removedX);
                        }
                        else {
                            newYArrMap.set(newY, [removedX]);
                        }
                        break;
                    }
                }
            }
        }
        return newYArrMap;
    }
    //相邻两行点之间有一片空间的话，需要补一行
    //在下一行中寻找对应X值，找到了就跳过，找不到就判断中间是否有空间（按理说只判断中点就行，如果中点不在里面而又有空间，应该是可以忽略的小空间）
    addMiddlePoint(y, yArr, yToRemovedXArr_map, polygon_local, polygonSegs_local) {
        let newYArrMap = new Map();
        let index = yArr.indexOf(y);
        let nextY = yArr[index + 1];
        let currentRow = yToRemovedXArr_map.get(y);
        let nextRow = yToRemovedXArr_map.get(nextY);
        if (nextRow) {
            for (let x of currentRow) {
                if (nextRow.indexOf(x) > -1) {
                    let middleY = (y + nextY) / 2;
                    let inPolygon = pipeCommonUtil_1.PipeCommonUtil.isInPolygon(new Coordinate_js_1.default(x, middleY), polygon_local, polygonSegs_local);
                    if (inPolygon === true) {
                        if (newYArrMap.has(middleY) === true) {
                            newYArrMap.get(middleY).push(x);
                        }
                        else {
                            newYArrMap.set(middleY, [x]);
                        }
                    }
                }
            }
        }
        return newYArrMap;
    }
    isExistedInXArrGroup(targetX, xArrGroup) {
        for (let xArr of xArrGroup) {
            for (let x of xArr) {
                if (Math.abs(targetX - x) < 800) {
                    return true;
                }
            }
        }
        return false;
    }
    findRows(y, yArr, yToXArr_map) {
        let index = yArr.indexOf(y);
        let preRows = [];
        for (let i = index - 1; i >= 0; i--) {
            preRows.push(this.getXArrGroup(yArr[i], yToXArr_map));
        }
        let nextRows = [];
        for (let i = index + 1; i < yArr.length; i++) {
            nextRows.push(this.getXArrGroup(yArr[i], yToXArr_map));
        }
        return {
            preRows: preRows,
            nextRows: nextRows,
        };
    }
    getXArrGroup(y, yToXArr_map) {
        for (let yToXArr of yToXArr_map) {
            if (y == yToXArr._y) {
                return yToXArr;
            }
        }
        throw Error("没找到对应行的喷头");
    }
    addNewXArrGroup(y, newXArrGroup, yToXArr_map) {
        yToXArr_map.push(new YToXArrGroup(y, newXArrGroup));
    }
}
exports.ChildPointAdjustUtil = ChildPointAdjustUtil;
class YToXArrGroup {
    constructor(y, xArrGroup) {
        this._y = y;
        this._xArrGroup = xArrGroup;
    }
}
exports.YToXArrGroup = YToXArrGroup;
